import React from "react";
import { withRouter } from "react-router-dom";
import Cookies from "js-cookie";

import logger from "js/core/logger";
import { withFirebaseAuth } from "js/react/views/Auth/FirebaseAuthContext";
import { withGoogleAuth } from "js/react/views/Auth/GoogleAuthContext";
import { LoadingPage } from "js/react/components/LoadingPage";

const log = logger.info(logger.AUTH).bind(logger);

export class Logout extends React.Component {
    constructor(props) {
        super(props);

        let continueUrl = new URL(window.location).searchParams.get("continue") || "/";

        if (continueUrl.startsWith("http")) {
            console.error("continue url must be relative");
            continueUrl = "/";
        }

        this.state = { continueUrl };
    }

    async componentDidMount() {
        const { auth, auth2 } = this.props;

        // sign out of google
        if (auth2.isSignedIn.get()) {
            log("will sign out of google");
            await auth2.signOut();
            log("did sign out of google");
        }

        // sign out of firebase
        if (auth.currentUser) {
            log("will sign out of firebase");
            await auth.signOut();
            log("did sign out of firebase");
        }

        const { continueUrl } = this.state;

        // wait until <FirebaseAuthProvider> does its thing
        auth.onAuthStateChanged(user => {
            // with page navigation (server needs `logged-in` cookie)
            if (continueUrl == "/") {
                Cookies.set("logged-in", false);
                window.location = "/";
            } else {
                // without page navigation (same as <Redirect>)
                this.props.history.push(continueUrl);
            }
        });
    }

    render() {
        return (
            <LoadingPage />
        );
    }
}

export default withGoogleAuth(withFirebaseAuth(withRouter(Logout)));
